// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__f2YJO"};